import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { useDeleteAccount } from '../hooks/useSettings';
import { ConfirmDialog, CancellationReasonForm, LoadingButton } from '../../../components/common';

export const WithdrawalSettings: React.FC = () => {
  const [password, setPassword] = useState('');
  const [cancellationReasonOpen, setCancellationReasonOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [withdrawalReasonCategory, setWithdrawalReasonCategory] = useState('');
  const [withdrawalReasonDetail, setWithdrawalReasonDetail] = useState('');

  const { mutate: deleteAccount, isPending } = useDeleteAccount();

  const handleWithdraw = () => {
    if (!password) return;
    setCancellationReasonOpen(true);
  };

  const handleConfirm = () => {
    deleteAccount({
      password,
      reason_category: withdrawalReasonCategory || undefined,
      reason_detail: withdrawalReasonDetail || undefined,
    });
  };

  return (
    <>
      <div className="border rounded-lg">
        {/* カードヘッダー */}
        <div className="px-6 py-5 border-b">
          <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#DC2626' }}>アカウントの退会</h3>
        </div>

        <div className="p-6 space-y-5">
          {/* 警告ボックス */}
          <div
            style={{
              background: '#FEF2F2',
              border: '1px solid #FECACA',
              borderRadius: '10px',
              padding: '16px 20px',
            }}
          >
            <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', marginBottom: '10px' }}>
              <AlertTriangle style={{ width: '18px', height: '18px', color: '#DC2626', flexShrink: 0, marginTop: '1px' }} />
              <p style={{ fontWeight: 700, fontSize: '14px', color: '#991B1B' }}>
                退会すると以下がすべて削除され、元に戻せません。
              </p>
            </div>
            <ul style={{ paddingLeft: '28px', listStyleType: 'disc', fontSize: '14px', color: '#B91C1C', lineHeight: 1.8 }}>
              <li>すべてのチャットボットと学習データ</li>
              <li>獲得したリード・会話履歴</li>
              <li>ご契約中のプラン（即時解約）</li>
            </ul>
          </div>

          {/* パスワード入力 + 退会ボタン */}
          <div>
            <label
              htmlFor="withdrawal-password"
              className="block text-sm font-medium mb-2"
            >
              確認のためパスワードを入力してください
            </label>
            <div className="flex items-center gap-3">
              <input
                id="withdrawal-password"
                type="password"
                placeholder="現在のパスワード"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="flex-1 px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-red-400"
              />
              <LoadingButton
                type="button"
                onClick={handleWithdraw}
                disabled={!password || isPending}
                loading={isPending}
                className="shrink-0 px-5 py-2 text-sm font-semibold rounded-lg text-white transition-colors disabled:opacity-40"
                style={{ backgroundColor: '#DC2626' }}
              >
                退会する
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>

      <CancellationReasonForm
        open={cancellationReasonOpen}
        onClose={() => setCancellationReasonOpen(false)}
        onConfirm={(category, detail) => {
          setWithdrawalReasonCategory(category);
          setWithdrawalReasonDetail(detail);
          setCancellationReasonOpen(false);
          setDialogOpen(true);
        }}
      />

      <ConfirmDialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
          setWithdrawalReasonCategory('');
          setWithdrawalReasonDetail('');
        }}
        onConfirm={handleConfirm}
        title="最終確認"
        message="本当にアカウントを削除しますか？この操作は元に戻せません。"
        confirmText="完全に削除する"
        variant="danger"
        loading={isPending}
      />
    </>
  );
};
